import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { headersToFooters } from '@views/reports/elements/ReportsPdfDocument/elements/ReportsPdfTable/utils/headersToFooter'

import { mapProfitAndLossBalances } from '../../../../utils/balanceMappers'
import { buildTableData } from '../../../../utils/buildTableData'
import { getVisibleColumns } from '../constants/columnConfiguration'
import { useProfitAndLossFilters } from '../contexts/profitAndLossFiltersContext'
import { getHeaderRow, getRowData, getSubHeaderRow } from '../utils/profitAndLossSpreadSheetFormatters'
import { useProfitAndLossData } from './useProfitAndLossData'

export const useProfitAndLossSpreadSheetExportData = () => {
  const { t } = useTranslation()
  const { reportData, allExpandableIds, periods } = useProfitAndLossData()
  const { appliedFilters } = useProfitAndLossFilters()

  const expandedRows = useMemo(
    () => allExpandableIds?.reduce((acc, id) => ({ ...acc, [id]: true }), {}) ?? {},
    [allExpandableIds],
  )

  const tableData = buildTableData(reportData, expandedRows, periods, mapProfitAndLossBalances)
  const visibleColumns = getVisibleColumns(appliedFilters.showChange, appliedFilters.showGroupPercentage)
  const sortedData = headersToFooters(tableData)

  const spreadSheetData = useMemo(() => {
    const columnsPerPeriod = visibleColumns.length

    return [
      getHeaderRow(periods, columnsPerPeriod),
      getSubHeaderRow(periods, visibleColumns, t),
      ...sortedData.map((row) => getRowData(row, periods, visibleColumns)),
    ]
  }, [periods, visibleColumns, sortedData, t])

  return { spreadSheetData }
}
